export default __webpack_public_path__ + "static/media/Gloria Romero.d0ffe615.jpg";